<!-- <h1 class="info-head" [innerHtml]="'OFFER.HEAD' | translate"></h1> -->
<p class="info-desc" [innerHtml]="'OFFER.DESC' | translate"></p>

<div class="info-cards">
  <div><img class="card" [src]=" assetsBaseUrl + 'cards/Club_Consumer_Visa.png'" alt="United Club Card" /></div>
  <div><img class="card" [src]=" assetsBaseUrl + 'cards/Club_Business_Visa.png'" alt="United ClubSM Business Card" /></div>
  <div><img class="card" [src]=" assetsBaseUrl + 'cards/Presidential_Plus_MasterCard.png'" alt="UnitedSM Presidential PlusSM Card" /></div>
  <div><img class="card" [src]=" assetsBaseUrl + 'cards/Presidential_Plus_Business_MasterCard.png'" alt="UnitedSM Presidential PlusSM Business Card" /></div>
</div>